export const mailSettingsKeys = {
  all: ['mail-settings'] as const,
  detail: () => [...mailSettingsKeys.all, 'detail'] as const,
}
